import React, { useMemo } from 'react';

export const Particles: React.FC = () => {
  const particles = useMemo(() => {
    return Array.from({ length: 18 }).map((_, i) => ({
      id: i,
      size: (i % 3) + 1.5,
      top: `${(i * 13) % 95}%`,
      left: `${(i * 17) % 95}%`,
      duration: 12 + (i % 8),
      delay: (i * 0.4) % 4,
    }));
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute rounded-full bg-white/15 animate-pulse"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            top: p.top,
            left: p.left,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            opacity: 0.2,
          }}
        />
      ))}
    </div>
  );
};
